export enum InquireBonusCodeErrors {
  ErrCodeIsNotAvailable = 18,
  ErrMemberThresholdNotMet = 56,
  ErrServerNeedsHelp = 100,
  ErrAdHasAlreadyBeenPayed,
  ErrCodeIsNotYours,
  ErrAdCannotBePayedFor,
  ErrCodeIsForFirstOrder,
  ErrTimeNotInPeriod,
  ErrPriceThresholdNotMet,
}

export const InquireBonusCodeErrorMessages = {
  [InquireBonusCodeErrors.ErrMemberThresholdNotMet]: "تعداد اعضای کانال مورد قبول نیست.",
  [InquireBonusCodeErrors.ErrServerNeedsHelp]:
    "مشکلی در اعمال کد هدیه وجود دارد. لطفا دقایقی دیگر مجددا تلاش کنید.",
  [InquireBonusCodeErrors.ErrAdHasAlreadyBeenPayed]: "این کد قبلاً استفاده شده است.",
  [InquireBonusCodeErrors.ErrCodeIsNotAvailable]: "کد وارد شده صحیح نیست.",
  [InquireBonusCodeErrors.ErrCodeIsNotYours]: "این کد برای شما قابل استفاده نیست.",
  [InquireBonusCodeErrors.ErrAdCannotBePayedFor]: "ظرفیت استفاده از این کد به اتمام رسیده است.",
  [InquireBonusCodeErrors.ErrCodeIsForFirstOrder]: "این کد مختص اولین سفارش است.",
  [InquireBonusCodeErrors.ErrTimeNotInPeriod]: "این کد در تاریخ انتخاب شده قابل استفاده نیست.",
  [InquireBonusCodeErrors.ErrPriceThresholdNotMet]: "حداقل قیمت کدتخفیف سفارش داده نشده است.",
};
